var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoGlobalTsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11265_28797",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.52588e-05H150V150H0V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11265_28797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.319 41.6144C107.227 29.8534 97.3401 20.4067 84.2995 17.4582C70.377 14.31 56.5129 19.3953 47.7988 29.4998",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.174 89.1617C129.65 88.7106 145.787 82.9918 147.63 73.2864C148.599 68.1817 145.48 62.6536 139.291 57.2996",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6379 32.4901C10.2597 35.1286 3.52379 39.6374 2.37155 45.7039C0.528481 55.4105 13.4496 66.6482 34.2017 75.3075",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.44 50.9904C118.18 43.599 100.355 37.0699 79.992 33.2033C62.943 29.9657 46.8622 29.1156 33.7949 30.3229",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4303 107.09L17.7109 123.035",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3249 57.1981L27.0781 96.9174",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.174 69.7021L105.012 139.612",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.651 86.545C111.711 85.2501 114.925 83.1381 115.462 80.3121C116.775 73.3998 101.643 64.6119 80.8027 59.7446",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2061 57.7047C48.7163 54.4328 31.0509 57.0435 29.7237 64.0308C29.187 66.857 31.4033 70 35.637 73.0601",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4759 52.7183C24.0245 55.0949 21.439 56.6002 18.7006 56.0801C15.9625 55.5601 14.1086 53.2123 14.5598 50.8354C15.0113 48.4588 17.597 46.9536 20.3351 47.4736C23.0732 47.9936 24.9271 50.3418 24.4759 52.7183Z",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1046 44.2508C50.6534 46.6274 48.0677 48.1326 45.3296 47.6126C42.5912 47.0926 40.7373 44.7444 41.1888 42.3679C41.64 39.9913 44.2257 38.486 46.9638 39.0061C49.7022 39.5261 51.5558 41.8742 51.1046 44.2508Z",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4466 47.3339C81.9952 49.7105 79.4097 51.2158 76.6713 50.6957C73.9333 50.1757 72.0793 47.8279 72.5305 45.451C72.982 43.0744 75.5677 41.5692 78.3058 42.0892C81.0439 42.6092 82.8978 44.9574 82.4466 47.3339Z",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.491 71.7105C124.04 74.0871 125.894 76.4352 128.632 76.9553C131.37 77.4753 133.956 75.97 134.408 73.5934C134.859 71.2166 133.005 68.8687 130.267 68.3487C127.528 67.8287 124.943 69.334 124.491 71.7105Z",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82 54.0711C102.368 56.4477 104.222 58.7958 106.96 59.3158C109.698 59.8355 112.284 58.3306 112.735 55.954C113.187 53.5771 111.333 51.2293 108.595 50.7093C105.857 50.1893 103.271 51.6945 102.82 54.0711Z",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6152 99.1273L63.1832 56.8065",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.981 61.3258L83.8477 85.1825",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2436 10.3878L33.7949 15.8362",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2436 15.8362L33.7949 10.3878",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.107 10.8997L110.658 16.348",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.107 16.3479L110.658 10.8996",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.554 104.93L116.105 110.379",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.554 110.379L116.105 104.93",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.376 32.4187C133.376 35.9129 130.544 38.7454 127.049 38.7454C123.555 38.7454 120.723 35.9129 120.723 32.4187C120.723 28.9245 123.555 26.092 127.049 26.092C130.544 26.092 133.376 28.9245 133.376 32.4187Z",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 32.4187C33.7959 35.9129 30.9632 38.7454 27.4689 38.7454C23.975 38.7454 21.1426 35.9129 21.1426 32.4187C21.1426 28.9245 23.975 26.092 27.4689 26.092C30.9632 26.092 33.7959 28.9245 33.7959 32.4187Z",
    stroke: "#59576D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGlobalTsvg);
export default __webpack_public_path__ + "static/media/noGlobalTsvg.9a9c97f1e889040d71ba5583646e0984.svg";
export { ForwardRef as ReactComponent };